import get from 'lodash-es/get';
import isEqual from 'lodash-es/isEqual';

interface ISelectItem {
  [ key: string ]: any;
}

export class ObjectUtilsService {

  equals( obj1: any, obj2: any, field?: string ): boolean {
    if ( field ) {
      return (this.resolveFieldData(obj1, field) === this.resolveFieldData(obj2, field));
    } else {
      return this.equalsByValue(obj1, obj2);
    }
  }

  equalsByValue( obj1: any, obj2: any ): boolean {
    return isEqual(obj1, obj2);
  }

  resolveFieldData( data: any, field: string ): string {
    if ( data && field ) {
      return get(data, field);
    }
    return null;
  }

  filter( value: any[], fields: any[], filterValue: string ) {
    const filteredItems: any[] = [];

    if ( value ) {
      for ( const item of value ) {
        for ( const field of fields ) {
          if ( String(this.resolveFieldData(item, field)).toLowerCase().indexOf(filterValue.toLowerCase()) > -1 ) {
            filteredItems.push(item);
            break;
          }
        }
      }
    }

    return filteredItems;
  }

  reorderArray( value: any[], from: number, to: number ) {
    let target: number;
    if ( value && (from !== to) ) {
      if ( to >= value.length ) {
        target = to - value.length;
        while ( (target--) + 1 ) {
          value.push(undefined);
        }
      }
      value.splice(to, 0, value.splice(from, 1)[ 0 ]);
    }
  }

  generateSelectItems( val: any[], field: string ): ISelectItem[] {
    // let selectItems: SelectItem[];
    // if(val && val.length) {
    //   selectItems = [];
    //   for(let item of val) {
    //     selectItems.push({label: this.resolveFieldData(item, field), value: item});
    //   }
    // }
    //
    // return selectItems;
    return [];
  }

  insertIntoOrderedArray( item: any, index: number, arr: any[], sourceArr: any[] ): void {
    if ( arr.length > 0 ) {
      let injected = false;
      for ( let i = 0; i < arr.length; i++ ) {
        const currentItemIndex = this.findIndexInList(arr[ i ], sourceArr);
        if ( currentItemIndex > index ) {
          arr.splice(i, 0, item);
          injected = true;
          break;
        }
      }

      if ( !injected ) {
        arr.push(item);
      }
    }
    else {
      arr.push(item);
    }
  }

  findIndexInList( item: any, list: any ): number {
    let index: number = -1;

    if ( list ) {
      for ( let i = 0; i < list.length; i++ ) {
        if ( list[ i ] === item ) {
          index = i;
          break;
        }
      }
    }

    return index;
  }
}



// WEBPACK FOOTER //
// ./app/core/services/object-utils/object-utils.service.ts